// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { useAuth } from '../components/auth/AuthContext';
// import {
//   Container,
//   Typography,
//   Box,
//   CircularProgress,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from '@mui/material';
// import { ExpandMore } from '@mui/icons-material';
// import axios from 'axios';
// import { Line } from 'react-chartjs-2';
// import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
// import htmlDocx from 'html-docx-js/dist/html-docx';

// // Register Chart.js components
// ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

// const getShortSubjectName = subject => {
//   const shortNames = {
//     Language: 'Lang',
//     Mathematics: 'Math',
//     'Psychomotor and Creative Arts': 'PCA',
//     Environmental: 'Env',
//     'Religious Education': 'RE',
//     'English Language': 'Eng',
//     'English Composition': 'Comp',
//     'Kiswahili Lugha': 'Kisw',
//     'Kiswahili Insha': 'Insha',
//     'Science and Technology': 'Sci/Tech',
//     'Science & Technology': 'Sci/Tech',
//     'Agriculture and Nutrition': 'Agri/Nut',
//     Agriculture: 'Agri',
//     'Social Studies': 'SS',
//     'Creative Arts & Sports': 'CAS',
//     'Creative Arts': 'Arts',
//     Science: 'Sci',
//     'Pre-Technical Studies': 'PTS',
//     'Pre-Technical': 'Pre-Tech',
//   };
//   return shortNames[subject] || subject;
// };

// const getExamDisplayTitle = (examType, examName) => {
//   if (['Random Exams', 'Other Exams'].includes(examType) && examName) {
//     return `${examType}: ${examName}`;
//   }
//   return examType;
// };

// const StudentDetailedAnalysis = () => {
//   const location = useLocation();
//   const { schoolId: contextSchoolId } = useAuth();
//   const { learnerId, learnerName, schoolId = contextSchoolId, grade } = location.state || {};
//   const [performanceData, setPerformanceData] = useState([]);
//   const [schoolDetails, setSchoolDetails] = useState({
//     schoolName: '',
//     schoolCode: '',
//     county: '',
//     subcounty: '',
//     location: '',
//     village: '',
//     address: '',
//     phoneNumber: '',
//     email: '',
//     website: '',
//   });
//   const [isLoading, setIsLoading] = useState(true);
//   const [isGenerating, setIsGenerating] = useState(false);

//   useEffect(() => {
//     const fetchSchoolDetails = async () => {
//       try {
//         const response = await axios.get('https://kidsm.vercel.app/api/schools/profile', { params: { schoolId } });
//         setSchoolDetails({
//           schoolName: response.data.schoolName || 'Unknown School',
//           schoolCode: response.data.schoolCode || 'Unknown Code',
//           county: response.data.county || 'Unknown County',
//           subcounty: response.data.subcounty || 'Unknown Subcounty',
//           location: response.data.location || 'Unknown Location',
//           village: response.data.village || 'Unknown Village',
//           address: response.data.address || 'Unknown Address',
//           phoneNumber: response.data.phoneNumber || 'Unknown Contact',
//           email: response.data.email || 'Unknown Email',
//           website: response.data.website || 'Not Specified',
//         });
//       } catch (error) {
//         console.error('Error fetching school details:', error);
//       }
//     };

//     const fetchLearnerPerformance = async () => {
//       try {
//         const response = await axios.get(`https://kidsm.vercel.app/api/schools/${schoolId}/performance`);
//         const learner = response.data.find(l => l._id === learnerId);
//         if (learner && learner.results) {
//           const organizedData = {};
//           learner.results.forEach(result => {
//             const { term, examType, examName, subject, marks } = result;
//             const examKey = getExamDisplayTitle(examType, examName);
//             if (!organizedData[term]) organizedData[term] = {};
//             if (!organizedData[term][examKey]) {
//               organizedData[term][examKey] = { subjects: {}, examType, examName };
//             }
//             organizedData[term][examKey].subjects[subject] = marks;
//           });
//           setPerformanceData(Object.entries(organizedData).map(([term, exams]) => ({ term, exams: Object.entries(exams) })));
//         }
//       } catch (error) {
//         console.error('Error fetching learner performance:', error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchSchoolDetails();
//     fetchLearnerPerformance();
//   }, [schoolId, learnerId]);

//   const subjects = [...new Set(performanceData.flatMap(termData =>
//     termData.exams.flatMap(([_, exam]) => Object.keys(exam.subjects))
//   ))];

//   const prepareSubjectTrendData = subject => {
//     const labels = [];
//     const data = [];
//     performanceData.forEach(termData => {
//       termData.exams.forEach(([examKey, exam]) => {
//         labels.push(`${termData.term} - ${examKey}`);
//         data.push(exam.subjects[subject] || 0);
//       });
//     });
//     return {
//       labels,
//       datasets: [{
//         label: getShortSubjectName(subject),
//         data,
//         borderColor: '#3182CE',
//         fill: false,
//       }],
//     };
//   };

//   const calculateExamAverages = exam => {
//     const marks = Object.values(exam.subjects).filter(mark => mark > 0);
//     const total = marks.reduce((sum, mark) => sum + mark, 0);
//     return marks.length > 0 ? Number((total / marks.length).toFixed(2)) : 0;
//   };

//   const generateCSVContent = () => {
//     const sections = [
//       [`School: ${schoolDetails.schoolName}`],
//       [`School Code: ${schoolDetails.schoolCode}`],
//       [`Address: ${[schoolDetails.village, schoolDetails.location, schoolDetails.subcounty, schoolDetails.county].filter(Boolean).join(', ')}`],
//       [`Physical Address: ${schoolDetails.address}`],
//       [`Contact: ${schoolDetails.phoneNumber}`],
//       [`Email: ${schoolDetails.email}`],
//       [`Website: ${schoolDetails.website}`],
//       [''],
//       [`Student: ${learnerName}`],
//       [`Grade: ${grade}`],
//       [''],
//     ];

//     performanceData.forEach(termData => {
//       sections.push([`Term: ${termData.term}`]);
//       sections.push(['Exam', ...subjects.map(getShortSubjectName), 'Average (%)']);
//       termData.exams.forEach(([examKey, exam]) => {
//         sections.push([
//           examKey,
//           ...subjects.map(subject => exam.subjects[subject] || '-'),
//           calculateExamAverages(exam),
//         ]);
//       });
//       sections.push(['']);
//     });

//     return sections.map(row => row.join(',')).join('\n');
//   };

//   const generateDocxContent = () => {
//     return `
//       <div style="font-family: Arial, sans-serif; padding: 30px;">
//         <h1 style="text-align: center; font-size: 24px;">${schoolDetails.schoolName}</h1>
//         <h2 style="font-size: 20px; margin-bottom: 10px;">Student Performance Analysis - ${learnerName}</h2>
//         <h3 style="font-size: 16px;">Grade: ${grade}</h3>
//         ${performanceData.map(termData => `
//           <h3>Term: ${termData.term}</h3>
//           <table style="width: 100%; border-collapse: collapse; margin-top: 12px;">
//             <thead>
//               <tr>
//                 <th style="background: #3182CE; color: #FFFFFF; padding: 12px; text-align: center;">Exam</th>
//                 ${subjects.map(subject => `<th style="background: #3182CE; color: #FFFFFF; padding: 12px; text-align: center;">${getShortSubjectName(subject)}</th>`).join('')}
//                 <th style="background: #3182CE; color: #FFFFFF; padding: 12px; text-align: center;">Average (%)</th>
//               </tr>
//             </thead>
//             <tbody>
//               ${termData.exams.map(([examKey, exam]) => `
//                 <tr>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${examKey}</td>
//                   ${subjects.map(subject => `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${exam.subjects[subject] || '-'}</td>`).join('')}
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${calculateExamAverages(exam)}</td>
//                 </tr>
//               `).join('')}
//             </tbody>
//           </table>
//         `).join('')}
//       </div>
//     `;
//   };

//   const createDocument = async (format) => {
//     try {
//       setIsGenerating(true);
//       const fileName = `Student_Performance_${learnerName.replace(/\s+/g, '_')}_${grade}`;

//       if (format === 'csv') {
//         const csvContent = generateCSVContent();
//         const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = `${fileName}.csv`;
//         a.click();
//         URL.revokeObjectURL(url);
//       } else if (format === 'docx') {
//         const htmlContent = generateDocxContent();
//         const docx = htmlDocx.asBlob(htmlContent);
//         const url = URL.createObjectURL(docx);
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = `${fileName}.docx`;
//         a.click();
//         URL.revokeObjectURL(url);
//       }
//     } catch (error) {
//       console.error(`Error generating ${format} report:`, error);
//       alert(`Failed to generate ${format} report. Please try again.`);
//     } finally {
//       setIsGenerating(false);
//     }
//   };

//   if (isLoading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress color="primary" />
//         <Typography sx={{ mt: 2, color: '#4A5568' }}>Loading Student Performance Data...</Typography>
//       </Box>
//     );
//   }

//   if (!performanceData.length) {
//     return (
//       <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh', textAlign: 'center' }}>
//         <Typography sx={{ color: '#E53E3E' }}>No performance data available for this student.</Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
//       <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
//         <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 2, textAlign: 'center' }}>
//           Performance Analysis - {learnerName}
//         </Typography>
//         <Paper sx={{ p: 2, mb: 3, bgcolor: '#fff', border: '1px solid #E2E8F0' }}>
//           <Typography variant="h6" sx={{ fontWeight: '600', color: '#2D3748' }}>{schoolDetails.schoolName}</Typography>
//           <Typography sx={{ color: '#4A5568' }}><strong>School Code:</strong> {schoolDetails.schoolCode}</Typography>
//           <Typography sx={{ color: '#4A5568' }}><strong>Address:</strong> {[schoolDetails.village, schoolDetails.location, schoolDetails.subcounty, schoolDetails.county].filter(Boolean).join(', ')}</Typography>
//           <Typography sx={{ color: '#4A5568' }}><strong>Physical Address:</strong> {schoolDetails.address}</Typography>
//           <Typography sx={{ color: '#4A5568' }}><strong>Contact:</strong> {schoolDetails.phoneNumber}</Typography>
//           <Typography sx={{ color: '#4A5568' }}><strong>Email:</strong> {schoolDetails.email}</Typography>
//           <Typography sx={{ color: '#4A5568' }}><strong>Website:</strong> {schoolDetails.website}</Typography>
//           <Typography sx={{ color: '#4A5568', mt: 1 }}><strong>Student:</strong> {learnerName}</Typography>
//           <Typography sx={{ color: '#4A5568' }}><strong>Grade:</strong> {grade}</Typography>
//         </Paper>

//         {/* Performance Overview */}
//         <Paper sx={{ p: 3, mb: 3, bgcolor: '#fff', border: '1px solid #E2E8F0' }}>
//           <Typography variant="h5" sx={{ fontWeight: '600', color: '#2D3748', mb: 2 }}>Performance Overview</Typography>
//           {performanceData.map(termData => (
//             <Box key={termData.term} sx={{ mb: 3 }}>
//               <Typography sx={{ fontWeight: '600', color: '#2D3748', mb: 1 }}>Term: {termData.term}</Typography>
//               <TableContainer>
//                 <Table>
//                   <TableHead>
//                     <TableRow sx={{ bgcolor: '#3182CE' }}>
//                       <TableCell sx={{ color: '#fff', fontWeight: '600' }}>Exam</TableCell>
//                       {subjects.map(subject => (
//                         <TableCell key={subject} sx={{ color: '#fff', fontWeight: '600' }}>{getShortSubjectName(subject)}</TableCell>
//                       ))}
//                       <TableCell sx={{ color: '#fff', fontWeight: '600' }}>Average (%)</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {termData.exams.map(([examKey, exam]) => (
//                       <TableRow key={examKey}>
//                         <TableCell>{examKey}</TableCell>
//                         {subjects.map(subject => (
//                           <TableCell key={subject}>{exam.subjects[subject] || '-'}</TableCell>
//                         ))}
//                         <TableCell sx={{ fontWeight: '600' }}>{calculateExamAverages(exam)}</TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Box>
//           ))}
//         </Paper>

//         {/* Subject Trends */}
//         <Paper sx={{ p: 3, mb: 3, bgcolor: '#fff', border: '1px solid #E2E8F0' }}>
//           <Typography variant="h5" sx={{ fontWeight: '600', color: '#2D3748', mb: 2 }}>Subject Performance Trends</Typography>
//           {subjects.map(subject => (
//             <Accordion key={subject} sx={{ mb: 2, bgcolor: '#fff', border: '1px solid #E2E8F0' }}>
//               <AccordionSummary expandIcon={<ExpandMore />}>
//                 <Typography sx={{ fontWeight: '600', color: '#2D3748' }}>{getShortSubjectName(subject)}</Typography>
//               </AccordionSummary>
//               <AccordionDetails>
//                 <Box sx={{ maxWidth: 800, mx: 'auto', mb: 2 }}>
//                   <Line
//                     data={prepareSubjectTrendData(subject)}
//                     options={{
//                       plugins: { legend: { position: 'top' } },
//                       scales: {
//                         y: { beginAtZero: true, title: { display: true, text: 'Marks (%)' } },
//                         x: { title: { display: true, text: 'Exam' } },
//                       },
//                     }}
//                   />
//                 </Box>
//               </AccordionDetails>
//             </Accordion>
//           ))}
//         </Paper>

//         {/* Download Buttons */}
//         <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
//           <Button
//             variant="contained"
//             sx={{ bgcolor: '#3182CE' }}
//             onClick={() => createDocument('csv')}
//             disabled={isGenerating}
//           >
//             {isGenerating ? <CircularProgress size={24} color="inherit" /> : 'Download Report (CSV)'}
//           </Button>
//           <Button
//             variant="outlined"
//             onClick={() => createDocument('docx')}
//             disabled={isGenerating}
//           >
//             {isGenerating ? <CircularProgress size={24} color="inherit" /> : 'Download Report (DOCX)'}
//           </Button>
//         </Box>
//       </motion.div>
//     </Container>
//   );
// };

// export default StudentDetailedAnalysis;

import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTeacherAuth } from '../auth/TeacherAuthContext';
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import axios from 'axios';
import { Line, Pie, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement, BarElement } from 'chart.js';
import htmlDocx from 'html-docx-js/dist/html-docx';

// Register Chart.js components
ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement, BarElement);

const getShortSubjectName = subject => {
  const shortNames = {
    Language: 'Lang',
    Mathematics: 'Math',
    'Psychomotor and Creative Arts': 'PCA',
    Environmental: 'Env',
    'Religious Education': 'RE',
    'English Language': 'Eng',
    'English Composition': 'Comp',
    'Kiswahili Lugha': 'Kisw',
    'Kiswahili Insha': 'Insha',
    'Science and Technology': 'Sci/Tech',
    'Science & Technology': 'Sci/Tech',
    'Agriculture and Nutrition': 'Agri/Nut',
    Agriculture: 'Agri',
    'Social Studies': 'SS',
    'Creative Arts & Sports': 'CAS',
    'Creative Arts': 'Arts',
    Science: 'Sci',
    'Pre-Technical Studies': 'PTS',
    'Pre-Technical': 'Pre-Tech',
  };
  return shortNames[subject] || subject;
};

const getExamDisplayTitle = (examType, examName) => {
  if (['Random Exams', 'Other Exams'].includes(examType) && examName) {
    return `${examType}: ${examName}`;
  }
  return examType;
};

const StudentDetailedAnalysis = () => {
  const location = useLocation();
  const { schoolId: contextSchoolId } =  useTeacherAuth();
  const { learnerId, learnerName, schoolId = contextSchoolId, grade } = location.state || {};
  const [performanceData, setPerformanceData] = useState([]);
  const [schoolDetails, setSchoolDetails] = useState({
    schoolName: '',
    schoolCode: '',
    county: '',
    subcounty: '',
    location: '',
    village: '',
    address: '',
    phoneNumber: '',
    email: '',
    website: '',
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isGenerating, setIsGenerating] = useState(false);
  const chartRefs = useRef({});

  useEffect(() => {
    const fetchSchoolDetails = async () => {
      try {
        const response = await axios.get('https://kidsm.vercel.app/api/schools/profile', { params: { schoolId } });
        setSchoolDetails({
          schoolName: response.data.schoolName || 'Unknown School',
          schoolCode: response.data.schoolCode || 'Unknown Code',
          county: response.data.county || 'Unknown County',
          subcounty: response.data.subcounty || 'Unknown Subcounty',
          location: response.data.location || 'Unknown Location',
          village: response.data.village || 'Unknown Village',
          address: response.data.address || 'Unknown Address',
          phoneNumber: response.data.phoneNumber || 'Unknown Contact',
          email: response.data.email || 'Unknown Email',
          website: response.data.website || 'Not Specified',
        });
      } catch (error) {
        console.error('Error fetching school details:', error);
      }
    };

    const fetchLearnerPerformance = async () => {
      try {
        const response = await axios.get(`https://kidsm.vercel.app/api/schools/${schoolId}/performance`);
        const learner = response.data.find(l => l._id === learnerId);
        if (learner && learner.results) {
          const organizedData = {};
          learner.results.forEach(result => {
            const { term, examType, examName, subject, marks } = result;
            const examKey = getExamDisplayTitle(examType, examName);
            if (!organizedData[term]) organizedData[term] = {};
            if (!organizedData[term][examKey]) {
              organizedData[term][examKey] = { subjects: {}, examType, examName };
            }
            organizedData[term][examKey].subjects[subject] = marks;
          });
          setPerformanceData(Object.entries(organizedData).map(([term, exams]) => ({ term, exams: Object.entries(exams) })));
        }
      } catch (error) {
        console.error('Error fetching learner performance:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchoolDetails();
    fetchLearnerPerformance();
  }, [schoolId, learnerId]);

  const subjects = [...new Set(performanceData.flatMap(termData =>
    termData.exams.flatMap(([_, exam]) => Object.keys(exam.subjects))
  ))];

  const prepareSubjectTrendData = subject => {
    const labels = [];
    const data = [];
    performanceData.forEach(termData => {
      termData.exams.forEach(([examKey, exam]) => {
        labels.push(`${termData.term} - ${examKey}`);
        data.push(exam.subjects[subject] || 0);
      });
    });
    return {
      labels,
      datasets: [{
        label: getShortSubjectName(subject),
        data,
        borderColor: `hsl(${(subjects.indexOf(subject) * 360) / (subjects.length || 1)}, 65%, 55%)`,
        fill: false,
      }],
    };
  };

  const prepareCombinedTrendData = () => {
    const labels = [];
    performanceData.forEach(termData => {
      termData.exams.forEach(([examKey]) => {
        labels.push(`${termData.term} - ${examKey}`);
      });
    });
    const datasets = subjects.map((subject, index) => ({
      label: getShortSubjectName(subject),
      data: performanceData.flatMap(termData =>
        termData.exams.map(([_, exam]) => exam.subjects[subject] || 0)
      ),
      borderColor: `hsl(${(index * 360) / (subjects.length || 1)}, 65%, 55%)`,
      fill: false,
    }));
    return { labels, datasets };
  };

  const preparePieData = exam => {
    return {
      labels: subjects.map(getShortSubjectName),
      datasets: [{
        data: subjects.map(subject => exam.subjects[subject] || 0),
        backgroundColor: subjects.map((_, index) => `hsl(${(index * 360) / (subjects.length || 1)}, 65%, 55%)`),
      }],
    };
  };

  const prepareBarData = exam => {
    return {
      labels: subjects.map(getShortSubjectName),
      datasets: [{
        label: 'Marks (%)',
        data: subjects.map(subject => exam.subjects[subject] || 0),
        backgroundColor: '#3182CE',
      }],
    };
  };

  const calculateExamAverages = exam => {
    const marks = Object.values(exam.subjects).filter(mark => mark > 0);
    const total = marks.reduce((sum, mark) => sum + mark, 0);
    return marks.length > 0 ? Number((total / marks.length).toFixed(2)) : 0;
  };

  const getChartImage = (chartKey) => {
    const canvas = chartRefs.current[chartKey]?.chartInstance?.canvas;
    return canvas ? canvas.toDataURL('image/png') : '';
  };

  const generateCSVContent = () => {
    const sections = [
      [`School: ${schoolDetails.schoolName}`],
      [`School Code: ${schoolDetails.schoolCode}`],
      [`Address: ${[schoolDetails.village, schoolDetails.location, schoolDetails.subcounty, schoolDetails.county].filter(Boolean).join(', ')}`],
      [`Physical Address: ${schoolDetails.address}`],
      [`Contact: ${schoolDetails.phoneNumber}`],
      [`Email: ${schoolDetails.email}`],
      [`Website: ${schoolDetails.website}`],
      [''],
      [`Student: ${learnerName}`],
      [`Grade: ${grade}`],
      [''],
      ['Performance Data'],
      ['Exam', ...subjects.map(getShortSubjectName), 'Average (%)'],
    ];

    performanceData.forEach(termData => {
      sections.push([`Term: ${termData.term}`]);
      termData.exams.forEach(([examKey, exam]) => {
        sections.push([
          examKey,
          ...subjects.map(subject => exam.subjects[subject] || '-'),
          calculateExamAverages(exam),
        ]);
      });
      sections.push(['']);
    });

    sections.push(['Combined Subject Trends']);
    sections.push(['Exam', ...subjects.map(getShortSubjectName)]);
    const labels = performanceData.flatMap(termData =>
      termData.exams.map(([examKey]) => `${termData.term} - ${examKey}`)
    );
    labels.forEach((label, index) => {
      sections.push([
        label,
        ...subjects.map(subject => {
          const examIndex = index;
          let currentIndex = 0;
          for (const termData of performanceData) {
            for (const [_, exam] of termData.exams) {
              if (currentIndex === examIndex) {
                return exam.subjects[subject] || '-';
              }
              currentIndex++;
            }
          }
          return '-';
        }),
      ]);
    });

    performanceData.forEach(termData => {
      termData.exams.forEach(([examKey, exam]) => {
        sections.push(['']);
        sections.push([`Pie and Bar Chart Data for ${examKey} (Term: ${termData.term})`]);
        sections.push(['Subject', 'Marks (%)']);
        subjects.forEach(subject => {
          sections.push([getShortSubjectName(subject), exam.subjects[subject] || '-']);
        });
      });
    });

    return sections.map(row => row.join(',')).join('\n');
  };

  const generateDocxContent = () => {
    const combinedTrendImage = getChartImage('combined-trend');
    return `
      <div style="font-family: Arial, sans-serif; padding: 30px;">
        <h1 style="text-align: center; font-size: 24px;">${schoolDetails.schoolName}</h1>
        <h2 style="font-size: 20px; margin-bottom: 10px;">Student Performance Analysis - ${learnerName}</h2>
        <h3 style="font-size: 16px;">Grade: ${grade}</h3>
        ${performanceData.map(termData => `
          <h3>Term: ${termData.term}</h3>
          <table style="width: 100%; border-collapse: collapse; margin-top: 12px;">
            <thead>
              <tr>
                <th style="background: #3182CE; color: #FFFFFF; padding: 12px; text-align: center;">Exam</th>
                ${subjects.map(subject => `<th style="background: #3182CE; color: #FFFFFF; padding: 12px; text-align: center;">${getShortSubjectName(subject)}</th>`).join('')}
                <th style="background: #3182CE; color: #FFFFFF; padding: 12px; text-align: center;">Average (%)</th>
              </tr>
            </thead>
            <tbody>
              ${termData.exams.map(([examKey, exam], examIndex) => `
                <tr>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${examKey}</td>
                  ${subjects.map(subject => `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${exam.subjects[subject] || '-'}</td>`).join('')}
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${calculateExamAverages(exam)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          ${termData.exams.map(([examKey, exam], examIndex) => `
            <h4 style="margin-top: 20px;">${examKey} - Performance Analysis</h4>
            <img src="${getChartImage(`${termData.term}-${examKey}-pie`)}" alt="${examKey} Pie Chart" style="width: 45%; margin-right: 5%; display: inline-block;" />
            <img src="${getChartImage(`${termData.term}-${examKey}-bar`)}" alt="${examKey} Bar Chart" style="width: 45%; display: inline-block;" />
            <img src="${getChartImage(`${termData.term}-${examKey}-line`)}" alt="${examKey} Line Chart" style="width: 90%; margin-top: 20px;" />
          `).join('')}
        `).join('')}
        <h3 style="margin-top: 20px;">Combined Subject Performance Trends</h3>
        <img src="${combinedTrendImage}" alt="Combined Subject Trends" style="width: 90%;" />
      </div>
    `;
  };

  const createDocument = async (format) => {
    try {
      setIsGenerating(true);
      const fileName = `Student_Performance_${learnerName.replace(/\s+/g, '_')}_${grade}`;

      if (format === 'csv') {
        const csvContent = generateCSVContent();
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${fileName}.csv`;
        a.click();
        URL.revokeObjectURL(url);
      } else if (format === 'docx') {
        const htmlContent = generateDocxContent();
        const docx = htmlDocx.asBlob(htmlContent);
        const url = URL.createObjectURL(docx);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${fileName}.docx`;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(`Error generating ${format} report:`, error);
      alert(`Failed to generate ${format} report. Please try again.`);
    } finally {
      setIsGenerating(false);
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress color="primary" />
        <Typography sx={{ mt: 2, color: '#4A5568' }}>Loading Student Performance Data...</Typography>
      </Box>
    );
  }

  if (!performanceData.length) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh', textAlign: 'center' }}>
        <Typography sx={{ color: '#E53E3E' }}>No performance data available for this student.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 2, textAlign: 'center' }}>
          Performance Analysis - {learnerName}
        </Typography>
        <Paper sx={{ p: 2, mb: 3, bgcolor: '#fff', border: '1px solid #E2E8F0' }}>
          <Typography variant="h6" sx={{ fontWeight: '600', color: '#2D3748' }}>{schoolDetails.schoolName}</Typography>
          <Typography sx={{ color: '#4A5568' }}><strong>School Code:</strong> {schoolDetails.schoolCode}</Typography>
          <Typography sx={{ color: '#4A5568' }}><strong>Address:</strong> {[schoolDetails.village, schoolDetails.location, schoolDetails.subcounty, schoolDetails.county].filter(Boolean).join(', ')}</Typography>
          <Typography sx={{ color: '#4A5568' }}><strong>Physical Address:</strong> {schoolDetails.address}</Typography>
          <Typography sx={{ color: '#4A5568' }}><strong>Contact:</strong> {schoolDetails.phoneNumber}</Typography>
          <Typography sx={{ color: '#4A5568' }}><strong>Email:</strong> {schoolDetails.email}</Typography>
          <Typography sx={{ color: '#4A5568' }}><strong>Website:</strong> {schoolDetails.website}</Typography>
          <Typography sx={{ color: '#4A5568', mt: 1 }}><strong>Student:</strong> {learnerName}</Typography>
          <Typography sx={{ color: '#4A5568' }}><strong>Grade:</strong> {grade}</Typography>
        </Paper>

        {/* Performance Overview */}
        <Paper sx={{ p: 3, mb: 3, bgcolor: '#fff', border: '1px solid #E2E8F0' }}>
          <Typography variant="h5" sx={{ fontWeight: '600', color: '#2D3748', mb: 2 }}>Performance Overview</Typography>
          {performanceData.map(termData => (
            <Box key={termData.term} sx={{ mb: 3 }}>
              <Typography sx={{ fontWeight: '600', color: '#2D3748', mb: 1 }}>Term: {termData.term}</Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#3182CE' }}>
                      <TableCell sx={{ color: '#fff', fontWeight: '600' }}>Exam</TableCell>
                      {subjects.map(subject => (
                        <TableCell key={subject} sx={{ color: '#fff', fontWeight: '600' }}>{getShortSubjectName(subject)}</TableCell>
                      ))}
                      <TableCell sx={{ color: '#fff', fontWeight: '600' }}>Average (%)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {termData.exams.map(([examKey, exam]) => (
                      <TableRow key={examKey}>
                        <TableCell>{examKey}</TableCell>
                        {subjects.map(subject => (
                          <TableCell key={subject}>{exam.subjects[subject] || '-'}</TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: '600' }}>{calculateExamAverages(exam)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {termData.exams.map(([examKey, exam]) => (
                <Box key={examKey} sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <Box sx={{ width: { xs: '100%', md: '45%' } }}>
                    <Typography sx={{ fontWeight: '500', color: '#4A5568', mb: 1 }}>{examKey} - Pie Chart</Typography>
                    <Pie
                      ref={ref => (chartRefs.current[`${termData.term}-${examKey}-pie`] = ref)}
                      data={preparePieData(exam)}
                      options={{ plugins: { legend: { position: 'bottom' } } }}
                    />
                  </Box>
                  <Box sx={{ width: { xs: '100%', md: '45%' } }}>
                    <Typography sx={{ fontWeight: '500', color: '#4A5568', mb: 1 }}>{examKey} - Bar Chart</Typography>
                    <Bar
                      ref={ref => (chartRefs.current[`${termData.term}-${examKey}-bar`] = ref)}
                      data={prepareBarData(exam)}
                      options={{
                        plugins: { legend: { display: false } },
                        scales: { y: { beginAtZero: true, title: { display: true, text: 'Marks (%)' } } },
                      }}
                    />
                  </Box>
                  <Box sx={{ width: '100%' }}>
                    <Typography sx={{ fontWeight: '500', color: '#4A5568', mb: 1 }}>{examKey} - Line Chart</Typography>
                    <Line
                      ref={ref => (chartRefs.current[`${termData.term}-${examKey}-line`] = ref)}
                      data={prepareBarData(exam)}
                      options={{
                        plugins: { legend: { display: false } },
                        scales: {
                          y: { beginAtZero: true, title: { display: true, text: 'Marks (%)' } },
                          x: { title: { display: true, text: 'Subject' } },
                        },
                      }}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
          ))}
        </Paper>

        {/* Subject Trends */}
        <Paper sx={{ p: 3, mb: 3, bgcolor: '#fff', border: '1px solid #E2E8F0' }}>
          <Typography variant="h5" sx={{ fontWeight: '600', color: '#2D3748', mb: 2 }}>Subject Performance Trends</Typography>
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontWeight: '500', color: '#4A5568', mb: 1 }}>Combined Subject Trends</Typography>
            <Line
              ref={ref => (chartRefs.current['combined-trend'] = ref)}
              data={prepareCombinedTrendData()}
              options={{
                plugins: { legend: { position: 'top' } },
                scales: {
                  y: { beginAtZero: true, title: { display: true, text: 'Marks (%)' } },
                  x: { title: { display: true, text: 'Exam' } },
                },
              }}
            />
          </Box>
          {subjects.map(subject => (
            <Accordion key={subject} sx={{ mb: 2, bgcolor: '#fff', border: '1px solid #E2E8F0' }}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography sx={{ fontWeight: '600', color: '#2D3748' }}>{getShortSubjectName(subject)}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{ maxWidth: 800, mx: 'auto', mb: 2 }}>
                  <Line
                    data={prepareSubjectTrendData(subject)}
                    options={{
                      plugins: { legend: { position: 'top' } },
                      scales: {
                        y: { beginAtZero: true, title: { display: true, text: 'Marks (%)' } },
                        x: { title: { display: true, text: 'Exam' } },
                      },
                    }}
                  />
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>

        {/* Download Buttons */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            sx={{ bgcolor: '#3182CE' }}
            onClick={() => createDocument('csv')}
            disabled={isGenerating}
          >
            {isGenerating ? <CircularProgress size={24} color="inherit" /> : 'Download Report (CSV)'}
          </Button>
          <Button
            variant="outlined"
            onClick={() => createDocument('docx')}
            disabled={isGenerating}
          >
            {isGenerating ? <CircularProgress size={24} color="inherit" /> : 'Download Report (DOCX)'}
          </Button>
        </Box>
      </motion.div>
    </Container>
  );
};

export default StudentDetailedAnalysis;